<template>
    <table class="table cart-table">
        <cart-item v-if="cart.items && cart.items.length > 0" v-for="item in cart.items" :key="item.id" :item="item"></cart-item>
        <tbody v-else>
            <tr>
                <td colspan="3">No items in your cart</td>
            </tr>
        </tbody>
        <tfoot>
        <tr>
            <td colspan="2" class="small-total text-right">Delivery</td>
            <td class="small-total text-right">
                <span  v-if="cart.shipping && cart.shipping.value === 0" class="text-success">Free</span>

                <span v-else>£{{ shipping.toString() }}</span>

            </td>
        </tr>
        <tr>
            <td colspan="2" class="small-total text-right">Total</td>
            <td class="small-total text-right">£{{ total.toString() }}</td>
        </tr>
        <tr v-if="hasHeavyItems">
            <td colspan="3">
                <p class="bg-info text-center">There are some heavy items in your cart please be aware we charge extra for delivery of these items</p>
            </td>
        </tr>
        </tfoot>
    </table>
</template>
<script>
    import Money from 'js-money';
    import CartItem from './cart-item.vue';


    export default {
        name: 'cart',

        data() {
            return {

            }
        },

        computed: {
            cart() {
                return this.$store.getters.currentCart;
            },

            shipping() {
                return new Money((this.cart.shipping) ? parseInt(this.cart.shipping.amount) : 0, Money.GBP);
            },

            total() {
                let total = new Money((this.cart.total) ? parseInt(this.cart.total.amount) : 0, Money.GBP);
                return total.add(this.shipping);
            },

            hasHeavyItems() {
                return _.filter(this.cart.items, {'heavy':true}).length > 0;
            }
        },

        created() {
            this
                .$store
                .dispatch('setShopCart', Laravel.cartId);
        }
    }
</script>
